import { render, staticRenderFns } from "./GoodsListItem.vue?vue&type=template&id=e9d327cc&"
import script from "./GoodsListItem.vue?vue&type=script&lang=js&"
export * from "./GoodsListItem.vue?vue&type=script&lang=js&"
import style0 from "./GoodsListItem.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports